import React, { useState, useEffect } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import moment from 'moment'
import { useConnectWallet } from '../../../hooks/useConnectWallet'
import { escapeRegExp } from '../../../utils/helpers'
import ListItems from './ListItems'
import IToken from '../../../images/token.png'
// import IInfo from '../../../images/info.png'
import { NAME_TOKEN } from '../../../constants'
import './style.scss'
import { AffiliateType } from '../../../models/affiliate.interface'
// import ModalInfo from '../../../components/ModalInfo'

interface IProps {
  balanceOfStaking: string | undefined
  account: string | undefined | null
  link: string
  affInfo: AffiliateType | null
  commission: string | '0'
  onUnStake: () => {}
  onGetReward: () => {}
}

const DashBoard = ({
  account,
  balanceOfStaking,
  link,
  onUnStake,
  affInfo,
  onGetReward,
}: IProps) => {
  const [Copied, setCopied] = useState(false)
  const [isShowInfo, setShowInfo] = useState(false)

  const CardInput = React.memo(function InnerInput({
    label,
    value,
    onChange,
    placeholder,
    id,
    // key,
    focusIndex,
    onFocus,
    onClick,
    disabled,
    buttonText,
    waitingWithdraw,
  }: {
    label: string
    value: string | number | undefined
    onChange?: (input: string) => void
    id: string
    // key: string
    focusIndex?: string
    onFocus?: (input: string) => void
    onClick?: () => void
    disabled?: boolean
    buttonText?: string
    waitingWithdraw?: any
  } & Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as'>) {
    const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`)

    const enforcer = (nextUserInput: string) => {
      if (
        nextUserInput === '' ||
        inputRegex.test(escapeRegExp(nextUserInput))
      ) {
        onChange && onChange(nextUserInput)
      }
    }

    return (
      <>
        <div className='label-input'>
          <h6 className='text-input'>{label}</h6>
        </div>
        <div className='card-input'>
          <div className='card-input--container'>
            <div className='container-input'>
              <input
                id={id}
                // key={key}
                className='input-swap'
                value={value}
                onChange={(event) => {
                  enforcer(event.target.value.replace(/,/g, '.'))
                }}
                onFocus={onFocus}
                inputMode='decimal'
                title='Token Amount'
                autoComplete='off'
                autoCorrect='off'
                autoFocus={focusIndex == id}
                type='text'
                pattern='^[0-9]*[.,]?[0-9]*$'
                placeholder={placeholder || '0.0'}
                minLength={1}
                maxLength={79}
                spellCheck='false'
                disabled={disabled}
              />
              {/* <div className='icon-token-container'> */}
              <span>
                <img alt='' src={IToken} />
                <span className='text-icon'>{NAME_TOKEN}</span>
              </span>
              {buttonText && (
                <div className='wrap-btn'>
                  <button
                    className={`btn outline-btn btn-input`}
                    onClick={onClick}
                    disabled={label === 'Earned' && Number(value) <= 100}
                  >
                    {buttonText}
                  </button>
                </div>
              )}

              {/* <button className='icon-info' onClick={() => setShowInfo(true)}>
                  <img alt='' src={IInfo} />
                </button> */}
              {/* </div> */}
            </div>
            {waitingWithdraw && label === 'Earned' ? (
              <div className='wrap-waiting'>
                <span className='text-success'>
                  waiting for approve: {waitingWithdraw.amount}
                </span>
                <span className='text-gray'>
                  Last updated :{' '}
                  {moment(waitingWithdraw.updatedAt).format('DD-MM-yyyy HH:mm')}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </>
    )
  })

  if (!affInfo) return null

  const {
    totalVisited = 0,
    numberOfTransactions = 0,
    earned = 0,
    commissions = [],
    profit = 0,
    waitingWithdraw = 0,
  } = affInfo

  return (
    <div className='dashboard-container'>
      <div className='card-dashboard'>
        <div className='card-dashboard--header'>
          <h5 color='text' className='text font-weight-bold'>
            One Pirate Referral Program
          </h5>
        </div>
        <div className='card-dashboard--content'>
          <div className='content'>
            <div className='d-flex justify-content-center'>
              <div className='ref-box'>
                <div className='wrap-link'>
                  <label className='label-link'>{link}</label>
                </div>
                <CopyToClipboard text={link} onCopy={() => setCopied(true)}>
                  <button className='btn secondary-btn copy-btn'>copy</button>
                </CopyToClipboard>
              </div>
            </div>

            <div className='wrap-content'>
              <div className='left-content'>
                <label className='text-header-content'>Affiliate Program</label>

                <label className='text-sub-header'>Link engagement</label>

                <div className='sale-info-box'>
                  <div className='info-content'>
                    <label className='info-number'>{totalVisited}</label>
                    <label>Impressions</label>
                  </div>

                  <div className='info-content right-info-content'>
                    <label className='info-number'>
                      {numberOfTransactions}
                    </label>
                    <label>Transactions (Swap)</label>
                  </div>
                </div>
                <CardInput
                  id='1'
                  // key='sell'
                  label='Earned'
                  value={earned}
                  buttonText='Claim'
                  onClick={onGetReward}
                  disabled
                  waitingWithdraw={waitingWithdraw}
                />
                <div className='text-center mt-3 mb-1'>
                  <span className='text-title'>
                    *The minimum claim is 100 ONEP
                  </span>
                </div>

                <CardInput
                  label='Staked'
                  id='2'
                  // key='staking'
                  value={balanceOfStaking}
                  buttonText='Unstake'
                  onClick={onUnStake}
                  disabled
                />
              </div>
              <div className='right-content'>
                <label className='text-header-content'>MLM</label>
                <ListItems totalProfit={profit} downlineList={commissions} />
              </div>
            </div>
          </div>
        </div>
        {/* <ModalInfo
          className='modal-info'
          title='What is get treasures (รอ text จริง)'
          account={account}
          isShowModal={isShowInfo}
          onCloseModal={() => setShowInfo(false)}
          compContent={
            <div className='d-flex  flex-column  justify-content-center warp-account-detail '>
              <div className='mt-10  d-flex flex-column  justify-conten-center'>
                <div className='d-flex flex-row  wrap-bsc-detail'>
                  <p className='text-info'>
                    You may think of staking as a less resource-intensive
                    alternative to mining. It involves holding funds in a
                    cryptocurrency wallet to support the security and operations
                    of a blockchain network. Simply put, staking is the act of
                    locking cryptocurrencies to receive rewards. In most cases,
                    you’ll be able to stake your coins directly from your crypto
                    wallet, such as Trust Wallet. On the other hand, many
                    exchanges offer staking services to their users.You may
                    think of staking as a less resource-intensive alternative to
                    mining. It involves holding funds in a cryptocurrency wallet
                    to support the security and operations of a blockchain
                    network. Simply put, staking is the act of locking
                    cryptocurrencies to receive rewards. In most cases, you’ll
                    be able to stake your coins directly from your crypto
                    wallet, such as Trust Wallet. On the other hand, many
                    exchanges offer staking services to their users.
                  </p>
                </div>
              </div>
            </div>
          }
        /> */}
      </div>
    </div>
  )
}

export default DashBoard
